if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const sectionId = this.dataset.sectionId;
      const productsToShow = parseInt(this.dataset.productsToShow || '4', 10);
      const currentHandle = this.dataset.currentProductHandle || '';
      const STORAGE_KEY = 'girnar_recently_viewed';

      let handles = [];
      try {
        handles = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (e) {
        handles = [];
      }

      if (!Array.isArray(handles)) handles = [];

      // Exclude current product if viewing product page
      if (currentHandle) {
        handles = handles.filter((handle) => handle !== currentHandle);
      }

      handles = handles.slice(0, productsToShow);

      if (handles.length === 0) {
        this.classList.add('hidden');
        this.style.display = 'none';
        return;
      }

      const searchQuery = handles.map((h) => `handle:${h}`).join(' OR ');
      const searchUrl = `${window.Shopify?.routes?.root || '/'}search?section_id=${sectionId}&type=product&q=${encodeURIComponent(searchQuery)}`;

      fetch(searchUrl)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const fetchedContent = doc.querySelector(`[data-id="${sectionId}"]`) || doc.querySelector('recently-viewed-products');

          if (fetchedContent) {
            const currentContainer = this.querySelector('.recently-viewed-inner') || this;
            const newContent = fetchedContent.querySelector('.recently-viewed-inner') || fetchedContent;

            currentContainer.innerHTML = newContent.innerHTML;
            this.classList.remove('hidden');
            this.style.display = '';

            // Re-order product grid items to match handles history order
            // const grid = this.querySelector('.product-grid');
            // if (grid && grid.children.length > 0) {
            //   const items = Array.from(grid.children);
            //   const sortedItems = [];
            //   handles.forEach((handle) => {
            //     const matchedItem = items.find((item) => {
            //       const cardLink = item.querySelector('a[href*="/products/"]');
            //       return cardLink && cardLink.href.includes(`/products/${handle}`);
            //     });
            //     if (matchedItem && !sortedItems.includes(matchedItem)) {
            //       sortedItems.push(matchedItem);
            //     }
            //   });

            //   items.forEach((item) => {
            //     if (!sortedItems.includes(item)) {
            //       sortedItems.push(item);
            //     }
            //   });

            //   sortedItems.forEach((item) => grid.appendChild(item));
            // }

            // Re-initialize Dawn SliderComponent if present
            const sliderComp = this.querySelector('slider-component');
            if (sliderComp && typeof sliderComp.resetPages === 'function') {
              sliderComp.resetPages();
            }
          }
        })
        .catch((error) => {
          console.error('Error fetching recently viewed products:', error);
          this.classList.add('hidden');
          this.style.display = 'none';
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}